import { useGlobalForm } from '../contexts/global-form-context';
import { useEffect } from 'react';

export interface MetaProps {
    title: string;
}

export function Meta({ title }: MetaProps) {
    const { others } = useGlobalForm();
    const titleMeta = others?.whitelabel?.name ? `${title} - ${others?.whitelabel?.name}` : 'Chargement...';

    useEffect(() => {
        document.title = titleMeta

        return () => {
            document.title = 'Chargement...';
        };
    }, [titleMeta]);

    return null
}
